<template>
    <div id="VehicleList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{pageTitle}}</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
                          <!-- commenting because not in use
                            <a v-if="pageType !== 'available-vehicles-for-order'" href="javascript:void(0)"
                                class="btn btn-secondary" v-on:click="openUpdateAssetModal()">
                               <i class="fp-import"></i> Update Asset
                            </a>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()">
                                <i class="fp-import"></i> Import
                            </a>
                            -->
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>
                          <a v-if="pageType==='available-vehicles-for-order'" href="javascript:void(0)"
                             class="btn btn-secondary" v-on:click="backToOrderPopUp()">
                            <i class="fp-back"></i> Back To Order
                          </a>
                            <router-link v-if="programMode && hideButton === false" class="btn btn-secondary"
                                v-bind:to="{name: 'ProgramList'}"> <i class="fp-back"> </i> Back</router-link>

                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left"
                            aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li><a href="javascript:void(0)" class="" v-on:click="exportCheck()">Export</a></li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-lists">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group"
                                    aria-label="Basic example">
                                    <button type="button" id="getAllAssetList" v-on:click="getAllAssetList(this)"
                                        :class="'btn btn-secondary '+ allSelected" v-if="pageType != 'my-vehicles'">
                                        All </button>
                                    <button type="button" id="getActiveAssetList" v-on:click="getActiveAssetList(this)"
                                        :class="'btn btn-secondary '+ activeSelected" v-if="pageType != 'my-vehicles'">
                                        Active </button>
                                    <button type="button" id="getInGarageAssetList"
                                        v-on:click="getInGarageAssetList(this)"
                                        :class="'btn btn-secondary '+ inGarageSelected"
                                        v-if="!hidetab || (pageType != 'my-vehicles' && pageType != 'available-vehicles-for-order')">
                                        In Garage </button>
                                    <button type="button" id="getSoldAssetList" v-on:click="getSoldAssetList(this)"
                                        :class="'btn btn-secondary '+ soldSelected"
                                        v-if="pageType != 'available-vehicles-for-order'"> Sold </button>
                                    <button type="button" id="getVoidAssetList" v-on:click="getVoidAssetList(this)"
                                        :class="'btn btn-secondary '+ voidSelected"
                                        v-if="!hidetab || (pageType == 'asset-list')"> Void </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="availabilityFromDate != null"
                            class="asset-filter-section form-row row-cols-md-1 row-cols-1">
                            <div class="col form-group">
                                <p class="filter-title">Available assets list for the selected filters.</p>
                                <div class="asset-filter">
                                    <p> <i class="fp-calendar"></i> <span> {{availabilityFromDate}} To
                                            {{availabilityToDate}} </span> </p>
                                </div>
                                <div v-if="availabilityLocation != ''" class="asset-filter">
                                    <p> <i class="fp-placeholder"></i> <span> {{availabilityLocation.text}} </span> </p>
                                </div>
                                <div v-if="availabilityAssetType != ''" class="asset-filter">
                                    <p> <i class="fp-rental"></i> <span> {{availabilityAssetType.text}} </span> </p>
                                </div>
                                <div class="asset-filter-close">
                                    <p> <a href="javascript:void(0)" v-on:click.prevent="removeAvailabilityFilter"> <i
                                                class="fp-close"></i> </a> </p>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="listName" ref="filterComponent"
                            @cancelSelection="cancelAll" :allowSameFilter="'allow'" :tempFilterId="tempFilterId"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in
                                process. batch no. is {{batchNum}}. <router-link class="color-blue"
                                    v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0">
                                    Click Here</router-link> to check file status!</p>
                            <section class="bg-white data-table">
                                <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                    :moduleName="'assetList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table ref="listVehicleTable" mode="remote" @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged" @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                                    :totalRows="totalRecords" :columns="userColumns" :rows="rows"
                                    @on-select-all="onSelectAll" :pagination-options="{
                                              enabled: false,
                                              position: 'both',
                                              setCurrentPage:listCurrentPage,
                                              perPage: perPage,
                                              perPageDropdown:dropDownPerPage,
                                              dropdownAllowAll: false,
                                          }" :select-options="{
                                              enabled: assetRowCheckbox,
                                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                              selectionInfoClass: 'custom-class',
                                              selectionText: 'rows selected',
                                              clearSelectionText: 'clear',
                                          }" :search-options="{
                                              enabled: false,
                                          }" :sort-options="{
                                              enabled: true,
                                          }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <!-- <template v-if="canUpdateAsset">
                                                    <router-link title="Edit Asset" class="fp-edit mr-3"
                                                        v-bind:to="{name: 'AssetEdit',params:{id:props.row.id}}"></router-link>
                                                </template> -->
                                                <a v-if="canViewLog" title="View Log"
                                                    v-on:click.prevent="goToGetLogInfo(props.row.id)"
                                                    style="font-size: 15px;"
                                                    class="fp-log-file-format" href="javascript:void(0)"></a>

                                            </div>
                                            <div v-else-if="props.column.field == 'vin' && canViewAsset === true">
                                                <template v-if="props.row.oos_veh_id != ''">
                                                    <router-link title="View Asset Details" class="color-red"
                                                        v-bind:to="{name: viewPage,params:{id:props.row.id},query:{from:pageType}}">{{props.row.vin}}</router-link>
                                                </template>
                                                <template v-else>
                                                    <router-link title="View Asset Details" class="color-blue"
                                                        v-bind:to="{name: viewPage,params:{id:props.row.id},query:{from:pageType}}">{{props.row.vin}}</router-link>
                                                </template>

                                            </div>
                                            <div v-else-if="props.column.field == 'list_in'">
                                                <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                            </div>
                                            <div v-else-if="props.column.field == 'option_code'">
                                                <span
                                                  class="popover-dismiss"
                                                  role="button"
                                                  tabindex="0"
                                                  data-container="body"
                                                  data-toggle="popover"
                                                  data-trigger="focus"
                                                  data-placement="right"
                                                  :data-content="
                                                        props.row.option_description ?
                                                        `${props.row.option_code} - ${props.row.option_description}`
                                                        : props.row.option_code"
                                                  style="cursor: pointer"
                                                >
                                                    {{ props.row.option_code }}
                                                </span>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="recallMode && !programMode && !hidetab" id="recallBtn"
                                            v-on:click.prevent="openRecallModal" class="btn btn-primary">Add Asset To
                                            Recall</button>
                                        <button v-if="flag === 'active' && !hidetab" id="createPOBtn"
                                            v-on:click.prevent="createPO" class="btn btn-primary">Create PO</button>
                                        <button v-if="pageType === 'available-vehicles-for-order' && !customOrderMode"
                                            id="placeOrderBtn" v-on:click.prevent="PlaceOrder"
                                            class="btn btn-primary">Place Order</button>
                                        <button v-if="pageType === 'asset-list' && canSellVehicle" id="sellVehicleBtn"
                                            v-on:click.prevent="sellVehicle" class="btn btn-primary">Sell
                                            Vehicle</button>

                                        <button v-if="programMode && !hidetab" id="recallBtn"
                                            v-on:click.prevent="openProgramModal" class="btn btn-primary">Add Asset To
                                            Program</button>
                                        <button v-if="customOrderMode && hidetab && canAssignVehicle" id="customOrderBtn"
                                            v-on:click.prevent="assignVehiclesToOrder" class="btn btn-primary">
                                          Assign Vehicle
                                        </button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                                </custom-pagination>
                            </section>
                        </div>
                        <div class="modal fade add-extra-charge-popup" id="recallModal" ref="recallModal"
                            data-backdrop="static" data-keyboard="false" aria-labelledby="recallModal"
                            aria-hidden="true">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModal1">Recall Asset</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form autocomplete="off" id="SelectDates" class="addinspectionForm">
                                            <div class="form-row row-cols-md-1 row-cols-1">
                                                <div class="col form-group">
                                                    <label>Recall:</label>
                                                    <v-select v-model="recalls" :options="recallArr" label="text"
                                                        name="recall" placeholder="Recall" id="recall"
                                                        class="custom-vselect">
                                                    </v-select>
                                                    <span class="field-error">{{errorDetails}}</span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="addRecallAssetBtn"
                                            v-on:click="addRecallAsset()">
                                            <i class="fp-submit"></i> {{submitBtnText}}
                                        </button>
                                        <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn"
                                            data-dismiss="modal">
                                            <i class="fp-close"></i> Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade add-extra-charge-popup" id="programModal" ref="programModal"
                            data-backdrop="static" data-keyboard="false" aria-labelledby="programModal"
                            aria-hidden="true">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModal1">Program</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form autocomplete="off" id="SelectDates" class="addinspectionForm">
                                            <div class="form-row row-cols-md-1 row-cols-1">
                                                <div class="col form-group">
                                                    <label class="control-label">Start Point Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="start_point_date"
                                                            name="start_point_date" v-model="start_point_date"
                                                            :config="optionsDate" aria-describedby="basic-addon3"
                                                            class="cal-icon"></date-picker>
                                                        <label for="start_point_date"
                                                            class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{start_point_date_error_msg}}</div>
                                                </div>
                                            </div>
                                        </form>
                                        <span class="field-error"> On skip the date trigger point will be set according
                                            to unit in service date. </span>
                                    </div>

                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="addPorgramAssetBtn"
                                            v-on:click="addAssetToProgram('save')">
                                            <i class="fp-submit"></i> Save
                                        </button>
                                        <button type="button" class="btn btn-tertiary" id="cancelProgramAssetBtn"
                                            v-on:click="addAssetToProgram('skip')">
                                            <i class="fp-close"></i> Skip
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- import model -->
                        <div class="modal fade asset-modal" id="asset-modal" ref="asset-modal" data-backdrop="static"
                            data-keyboard="false" aria-labelledby="asset-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2"
                                                        for="name">File:</label><br />
                                                    <input id="assetFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_update_asset_error}}</div>
                                                </div>
                                            </div>
                                        </form>
                                        <div class="form-row">
                                            <div class="col form-group" v-if="fileUpdateAssetName != ''">
                                                <label class="control-label"> Download Sample file </label>
                                                <a href="javascript:void(0)" v-on:click="downloadUpdateAssetSample()">
                                                    <i class="fp-text-document"></i> {{fileUpdateAssetName}} </a>
                                            </div>
                                        </div>
                                        <template v-if="unitnotfound && unitnotfound.length > 0">
                                            <!-- <p>&nbsp;</p> -->
                                            <label class="d-block"> Unit Code Not Found:</label>
                                            <template v-for="(unit,unitKey) in unitnotfound">
                                                <a :key="unitKey" v-if="unitKey > 0"> | &nbsp;</a><span
                                                    :key="unitKey">{{unit}}</span>
                                            </template>
                                            <!-- <p>&nbsp;</p> -->
                                        </template>
                                        <template v-if="wrongdate && wrongdate.length > 0">
                                            <!-- <p>&nbsp;</p> -->
                                            <label class="d-block"> Wrong Date Format:</label>
                                            <template v-for="(date,dateKey) in wrongdate">
                                                <a :key="dateKey" v-if="dateKey > 0"> | &nbsp;</a><span
                                                    :key="dateKey">{{date}}</span>
                                            </template>
                                            <p>&nbsp;</p>
                                        </template>
                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i
                                                    class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton"
                                                v-on:click="importUpdateAssetAsset()"> <i class="fp-import"> </i>
                                                Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- import model -->

                        <div class="modal fade vehicle-upload-modal" id="vehicle-upload-modal"
                            ref="vehicle-upload-modal" data-backdrop="static" data-keyboard="false"
                            aria-labelledby="vehicle-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importIFTAFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2"
                                                        for="name">File:</label><br />
                                                    <input id="vehicleUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="generateExcelSample()"> <i
                                                            class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>

                                            <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i>
                                                &nbsp;<strong>{{importedCount}} Records imported</strong></p>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i
                                                    class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton"
                                                v-on:click="importVehicles()"> <i class="fp-import"> </i>
                                                Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";
    import {commonMixins} from '../mixins/commonMixins';
    import { contractMixins } from '../mixins/contractMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';
    import AuditLogPopUp from "./AuditLogPopUp.vue";
    import {useAssignedVehiclesList} from "../store/AssignedVehiclesList";
    Vue.component("audit-log-popup",AuditLogPopUp);

    export default {
        name: "VehicleList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "",
        },
        components: {



        },
        mixins:[commonMixins, contractMixins, dataTableMixins],
        props: {
          fuelAssetListVal: {
              type: String,
              required: false,
              default:undefined
          },
        },
        data: () => ({
            pageTitle:"",
            hideButton: false,
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            canViewAsset:true,
            userColumns:[],
            velocity_env:process.env.NODE_ENV,
            hidetab:false,
            pageType: "asset-list",
            viewPage: "AssetView",
            columns: [
                 {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:true,
                },
                {
                    label: 'Vin',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
              {
                label: 'Model #',
                field: 'model_code',
                filterable: true,
                fpFieldType: "option",
                hidden: false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Model", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter", //only trigger on enter not on keyup
                  filterDropdownItems:[
                    'e16L',
                    'e16M',
                    'e18L',
                    'e18M',
                  ],
                }
              },
              {
                label: 'Wheelbase',
                field: 'wheelbase',
                fpFieldType: "option",
                filterable: true,
                hidden: false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Wheelbase", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter", //only trigger on enter not on keyup
                  filterDropdownItems: [
                    '134',
                    '152',
                    '175',
                    '187'
                  ]
                }
              },
              {
                label: 'Option Code',
                field: 'option_code',
                filterable: true,
                fpFieldType: "option",
                hidden: false,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Option Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter", //only trigger on enter not on keyup
                  filterDropdownItems: [],
                }
              },
                {
                    label: 'Color',
                    field: 'color',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset color", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Ownership',
                    field: 'ownership',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ownership", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#Customer Unit',
                    field: 'customer_unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Customer Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Port Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Purchase Date',
                    field: 'purchase_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Purchase Price',
                    field: 'price',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Purchase Price", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Dealer Code',
                    field: 'dealer_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Dealer Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Dealer Name',
                    field: 'dealer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Dealer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Legacy Unit Number',
                    field: 'old_unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Legacy Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteAsset: false,
            loading:false,
            canAddAsset:false,
            canUpdateAsset:false,
            accessCheckAvailability:false,
            selectedAssetFile:"",
            recallMode:false,
            errorDetails:'',
            recalls:'',
            recallArr:[],
            assetRowCheckbox:false,
            action:"list",
            submitBtnText:"Submit",
            pageKey:"_vehicle_list_",
            programMode:false,
            batchProcess:0,
            batchNum:"",
            start_point_date_error_msg:'',
            start_point_date:'',
            import_update_asset_error:"",
            unitnotfound:[],
            wrongdate:[],
            fileUpdateAssetName:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                toolbarPlacement:'bottom',
                widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
                },
            },
            flag:"active",
            activeSelected:'',
            inGarageSelected:'',
            soldSelected:'',
            voidSelected:'',
            allSelected: '',
            isEnableAssetGroup:false,
	        isEnableAssetPool:false,
            selectedCustomerFromAsset:null,
            customOrderMode:false,
            importedCount:0,
            import_error:'',
            fileName:'VehicleUpload',
            viewOwnerShipFields: false,
            canSellVehicle: false,
            canViewLog: false,
            logs: [],
            popUpTitle: "Vehicle Activity Log Details",
            vehicleSpecification: {},
            tempFilterId: 0,
            orderQty: 0,
            canAssignVehicle: false,
            assignVehiclesList: useAssignedVehiclesList(),
            bypassConfirmation: true,
            listName: 'assetList',
            viewDaysInStock: false
        }),
        beforeRouteLeave(to, from, next) {
          if (this.pageType == "available-vehicles-for-order") {
            if (this.bypassConfirmation) {
              this.assignVehiclesList.updateFilterStatus(false);
              next();
            } else {
              if (confirm("Vehicle assignment changes will not be saved!")) {
                next(); // Proceed with navigation
                this.assignVehiclesList.updateFilterStatus(false);
              } else {
                // Restore the URL without query parameters
                next(false); // Cancel navigation

                // Directly update the browser URL without affecting history
                window.history.replaceState(null, "", from.path);
              }
            }
          } else {
            this.assignVehiclesList.updateFilterStatus(false);
            next();
          }
        },
        created() {
          window.addEventListener('beforeunload', this.beforeWindowUnload)
        },
        beforeDestroy() {
          window.removeEventListener('beforeunload', this.beforeWindowUnload)
        },
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                      if(self.velocity_env === 'velev' || self.velocity_env === 'velev_test'){
                        if (permissions[i].name === 'ev_list_vehicle') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name === 'ev_delete_vehicle') {
                            self.canDeleteAsset = true;
                        }
                        if (permissions[i].name === 'ev_add_vehicle') {
                            self.canAddAsset = true;
                            self.canUpdateAsset = true;
                        }
                        if (permissions[i].name === 'ev_view_vehicle') {
                            self.canViewAsset = true;
                        }

                        if (permissions[i].name === 'ev_check_vehicle_availability') {
                            self.accessCheckAvailability = true;
                        }
                        if (permissions[i].name === 'ev_add_vehicle_to_recall') {
                            self.recallMode = true;
                        }
                        //row-selection checkbox
                        if (permissions[i].name === 'ev_delete_vehicle' || permissions[i].name === 'ev_add_vehicle_to_recall') {
                           if(self.$route.query.flag === 'assetReport'){
                              self.assetRowCheckbox = false;
                          } else{
                              self.assetRowCheckbox = true;
                          }

                        }
                        if(permissions[i].name === "ev_view_ownership_fields"){
                          self.viewOwnerShipFields = true;
                        }
                        if(permissions[i].name === "ev_change_vehicle_status_to_sold"){
                          self.canSellVehicle = true;
                        }
                        if(permissions[i].name === "ev_vehicle_view_audit_log"){
                          self.canViewLog = true;
                          for (const element of this.columns) {
                            if (element.field === 'action') {
                              this.$set(element, 'hidden', false)
                            }
                          }
                        }
                        if(permissions[i].name === 'ev_assign_vehicle_to_order'){
                          self.canAssignVehicle = true;
                        }
                      }else{
                        if (permissions[i].name === 'list_asset') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name === 'delete_asset') {
                            self.canDeleteAsset = true;
                        }
                        if (permissions[i].name === 'add_asset') {
                            self.canAddAsset = true;
                            self.canUpdateAsset = true;
                        }
                        if (permissions[i].name === 'view_asset') {
                            self.canViewAsset = true;
                        }

                        if (permissions[i].name === 'check_asset_availability') {
                            self.accessCheckAvailability = true;
                        }
                        if (permissions[i].name === 'add_asset_to_recall') {
                            self.recallMode = true;
                        }
                        //row-selection checkbox
                        if (permissions[i].name === 'delete_asset' || permissions[i].name === 'add_asset_to_recall') {
                           if(self.$route.query.flag === 'assetReport'){
                              self.assetRowCheckbox = false;
                          } else{
                              self.assetRowCheckbox = true;
                          }

                        }
                      }
                      if (permissions[i].name === 'ev_view_days_in_stock') {
                        self.viewDaysInStock = true;
                      }
                    }
                    self.configureColumns();
                }

            },
          tempFilterId(value) {
            if (value > 0) {
              this.$nextTick(() => {
                const checkRef = setInterval(() => {
                  if (this.$refs.filterComponent) {
                    this.$refs.filterComponent.loadDefaultFiltersOnload();
                    clearInterval(checkRef);
                  } else {
                    console.warn("Waiting for filterComponent ref to be available.");
                  }
                }, 100);
              });
            }
          }
        },
        computed: {
          assignedVehicles(){
            return useAssignedVehiclesList().vehicles;
          },
          unAssignedVehicles() {
            return useAssignedVehiclesList().unAssignedVehicles;
          }
        },

      mounted: function () {
        var self = this;
        var page = this.$route.path.split('/');
        if (page[1] === "my-vehicles") {
          self.pageType = "my-vehicles";
          self.pageTitle = "My Vehicle List";
          self.listName = 'myVehicles';
          self.$options.metaInfo.title = `My Vehicle List | ${process.env.COPYRIGHT_NAME}`;
          for (const element of this.columns) {
            if (element.field === 'status'){
              this.$set(element, 'filterable', false)
            }
          }
        } else if (page[1] === "available-vehicles-for-order") {
          this.initializeVehicleForOrder();
        } else if (page[1] === "all-vehicles") {
          self.pageType = "asset-list";
          self.pageTitle = "All Vehicle List";
          self.$options.metaInfo.title = `All Vehicle List | ${process.env.COPYRIGHT_NAME}`;
        }

        //self.loadList();
        self.getPermissions();
        if (self.velocity_env == 'velev' || self.velocity_env == 'velev_test') {
          self.hidetab = true;
          self.sortColumns();
        }
        self.loadFieldData(['enable_asset_group', 'enable_asset_pool']);

        if (self.$route.query.flag == 'assetReport') {
          self.hideButton = true;
          self.pageTitle = "Equipment Master";
          for (let index = 0; index < this.columns.length; index++) {

            if (this.columns[index].field == 'action') {
              this.$set(this.columns[index], 'hidden', true);
            }
          }
        }

        // when user came back from other page this will load the same tab selected before
        $('#divTabMenu button').removeClass("active");
        var prevSelectedTab = localStorage.getItem("asset_list_prev_tab");

        if (prevSelectedTab == null) {
          self.flag = "all";
          self.allSelected = 'active';
          localStorage.setItem('asset_list_prev_tab', 'all');
        } else {
          if (prevSelectedTab == 'ingarage') {
            self.flag = "in garage";
            self.inGarageSelected = 'active';
          } else if (prevSelectedTab == 'sold') {
            self.flag = "sold";
            self.soldSelected = 'active';
          } else if (prevSelectedTab == 'void') {
            self.flag = "void";
            self.voidSelected = 'active';
          } else if (prevSelectedTab == 'active') {
            self.flag = "active";
            self.activeSelected = 'active';
          } else {
            self.flag = "all";
            self.allSelected = 'active';
          }
        }

        self.availabilityFromDate = localStorage.getItem("availabilityFromDate");
        self.availabilityToDate = localStorage.getItem("availabilityToDate");
        if (localStorage.getItem("availabilityLocation") != null) {
          self.availabilityLocation = JSON.parse(localStorage.getItem("availabilityLocation"));
        }
        if (localStorage.getItem("availabilityAssetType") != null) {
          self.availabilityAssetType = JSON.parse(localStorage.getItem("availabilityAssetType"));
        }

        // if(self.$route.query.from == 'recall'){
        //     self.recallMode = true;
        // }
        if (self.$route.query.from && self.$route.query.from == 'program') {
          self.programMode = true;
        }
        if (self.$route.query.from && self.$route.query.from == 'vehicle_order') {
          self.customOrderMode = true;
        }
        self.$nextTick(() => {
          self.initializePopovers();
          const colorColumn = self.columns.find(col => col.field === 'color');
          if (colorColumn) {
            colorColumn.label = self.color_spelling;
          }
        });

      },
        updated: function() {
            var self = this;
            //hide asset group and pool columns based on params settings
            //setTimeout(function () {
            for (var i = 0; i < self.columns.length; i++) {
                if(self.velocity_env != 'velev' || self.velocity_env != 'velev_test'){
                  if(self.isEnableAssetGroup == false && self.columns[i].field=='asset_group'){
                      //hide
                      self.columns[i].hidden = true;
                      self.columns[i].filterable = false;
                  } else if (self.isEnableAssetGroup && self.columns[i].field=='asset_group'){
                      //show
                      self.columns[i].hidden = false;
                      self.columns[i].filterable = true;
                  }
                  if(self.isEnableAssetPool == false && self.columns[i].field=='asset_pool'){
                      //hide
                      self.columns[i].hidden = true;
                      self.columns[i].filterable = false;
                  } else if (self.isEnableAssetPool && self.columns[i].field=='asset_pool'){
                      //show
                      self.columns[i].hidden = false;
                      self.columns[i].filterable = true;
                  }
                }
                if(self.pageType === "available-vehicles-for-order"){
                  if(self.columns[i].field == "model_code"){
                    self.columns[i].filterable = false;
                  }
                  if(self.columns[i].field == "wheelbase"){
                    self.columns[i].filterable = false;
                  }
                  if(self.columns[i].field == "option_code"){
                    self.columns[i].filterable = false;
                  }
                  if(self.columns[i].field == "color"){
                    self.columns[i].filterable = false;
                  }
                }
            }
            //}, 2500);
            self.initializePopovers();
        },
        methods: {
          initializeVehicleForOrder(){
            if(this.$route.query && this.$route.query.from){
              this.assignVehiclesList.updateFilterStatus(true);
              this.listName = "availableAssetList";
              this.bypassConfirmation = false;
              this.pageType = "available-vehicles-for-order";
              this.pageTitle = "Available Vehicle List";
              this.vehicleSpecification = JSON.parse(this.$route.query.fields);
              this.orderQty = this.$route.query.orderQuantity;
              this.saveVehicleSpecificationFilters();
              this.$options.metaInfo.title = `Available Vehicle List | ${process.env.COPYRIGHT_NAME}`;
            }else{
              this.redirectToVehicleOrderTracking();
            }
          },
            initializePopovers() {
                this.$nextTick(() => {
                  // destroy any existing popovers first (optional, but avoids duplicates)
                  $('.popover-dismiss').popover('dispose');
                  // re-initialize with focus trigger
                  $('.popover-dismiss').popover({
                    trigger: 'focus'
                  });
                });
            },
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listVehicleTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
            removeAvailabilityFilter() {

                var self = this;

                self.availabilityFromDate = null;
                self.availabilityToDate = null;
                self.availabilityLocation = "";
                self.availabilityAssetType = "";


                self.serverParams.columnFilters.availabilityFromDate = "";
                self.serverParams.columnFilters.availabilityToDate = "";
                self.serverParams.columnFilters.availabilityAssetTypeId = "";
                self.serverParams.columnFilters.availabilityLocationId = "";


                //remove localstorage data
                localStorage.removeItem('availabilityFromDate');
                localStorage.removeItem('availabilityToDate');
                localStorage.removeItem('availabilityLocation');
                localStorage.removeItem('availabilityAssetType');

                this.loadList();
            },

            onRowClick(params){
              if (params.row.id != '')
              {
                var index = params.row.id;
                if (index > -1) {
                    this.$emit('fuelPricingAssetId', index)
                }
              }else{
                  return "Nothing is selected!";
              }
            },

            loadList() {

                var self = this;
                self.loading = true;

                //self.serverParams.columnFilters = params;

                var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listVehicleTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                }
                if( self.recalls != null || self.recalls!= ''){
                    var fields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        selectedRows:selectedRows,
                        action:self.action,
                        selectedAll:self.serverParams.selectedAll,
                        recallId:self.recalls.value,
                        flag:self.flag,
                        listData: self.pageType,
                        assignedVehicles: JSON.stringify(self.assignedVehicles),
                        unAssignedVehicles: JSON.stringify(self.unAssignedVehicles)
                    };
                }else{
                    var fields = {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        selectedRows:selectedRows,
                        action:self.action,
                        selectedAll:self.serverParams.selectedAll,
                        flag:self.flag,
                        listData: self.pageType,
                        assignedVehicles: JSON.stringify(self.assignedVehicles),
                        unAssignedVehicles: JSON.stringify(self.unAssignedVehicles)
                    };
                }



                if ( self.availabilityFromDate != null ) {
                    fields.filters.availabilityFromDate = self.availabilityFromDate;
                    fields.filters.availabilityToDate = self.availabilityToDate;
                }
                if ( self.availabilityAssetType != "") {
                    fields.filters.availabilityAssetTypeId = self.availabilityAssetType.value;
                }
                if ( self.availabilityLocation != "") {
                    fields.filters.availabilityLocationId = self.availabilityLocation.value;
                }


                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/asset/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteVehicleBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            } else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                // self.loadList();

                            } else if ( self.action == "recall" ) {
                                self.submitBtnText = "Submit";
                                $("#addRecallAssetBtn").prop("disabled", false);
                                $("#cancelRecallAssetBtn").prop("disabled", false);
                                $("#recallModal").modal('hide');
                                self.action = "list";
                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                            var url = '&recallValue='+self.recalls.value+'&recallText='+self.recalls.text;
                                            self.$router.push({ name: 'RecallAssetMapper', query: { data : btoa(url) }});
                                            self.recalls = '';

                                        } else if (result.dismiss) {
                                            self.recalls = '';
                                            return;
                                        }
                                });

                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'delete-asset-list')
                        }
                        else if ( self.action == "export" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'export-asset-list')
                        }
                        else if ( self.action == "recall" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'recall-asset-list')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'get-asset-list')
                        }

                    }
                });
            },
            VehicleDelete() {

                if (confirm('Are you sure that you want to delete this Asset? ')) {

                    this.action = "delete";
                    $("#deleteVehicleBtn").val("Deleting ...");

                    this.loadList();

                }
            },
            syncAsset() {

                var self = this;
                self.loading = true;
                $("#syncAssetBtn").text("Syncing...");
                $("#syncAssetBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/sync-asset",
                    type: "GET",
                    // data: 'id=' + use,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);

                        if (data.status == 'success') {

                            self.$swal({
                                // title: data.content + " " ,
                                text: data.content + " Asset are Sync.",
                                type: "success",
                                confirmButtonText: "Confirm",
                            }).then(result => {
                                if (result.value) {
                                    self.loadList();
                                }
                            });
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#syncAssetBtn").text("Sync");
                        $("#syncAssetBtn").prop("disabled", false);
                        self.generateStatusCodeMessage(jqXHR,true,'')

                    }
                });
            },
            openRecallModal: function(){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/recalls/get",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.recallArr = data.content;
                            $("#recallModal").modal('show');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-recall-get')

                    }
                });
            },
            openProgramModal: function(){
                var self = this;
                self.start_point_date_error_msg = '';
                self.start_point_date = '';
                $("#programModal").modal('show');
            },


            addRecallAsset() {

                var error = false;
                var self = this;
                self.errorDetails = "";
                self.action = "recall";

                if (self.recalls == null || self.recalls == '' ||!self.recalls.value) {
                    self.errorDetails = "Recall Required.";
                    error = true;
                }

                if(!error){
                    self.submitBtnText = "In Progress ...";
                    $("#addRecallAssetBtn").prop("disabled", true);
                    $("#cancelRecallAssetBtn").prop("disabled", true);
                    self.loadList();
                }
            },
            assignVehiclesToOrder(){
                var self = this;
                var data = this.$refs['listVehicleTable'].selectedRows;

                var order = self.$route.query.order;

                if(data.length > this.orderQty){
                  self.$swal('', `You have ordered the maximum limit of ${this.orderQty} vehicles. You cannot select more.`, 'info');
                    return;
                }

              if (confirm('Are you sure that you want to assign these vehicles to Order? ')) {
                self.loading = true;
                self.bypassConfirmation = true;
                var order = self.$route.query.order;

                for (var i = 0; i < data.length; i++) {
                  self.assignVehiclesList.pushVehicle(
                    {
                      'vin': this.$refs['listVehicleTable'].selectedRows[i].vin,
                      'assigned_vehicle_id':this.$refs['listVehicleTable'].selectedRows[i].id,
                      'laravel_through_key': order,
                    }
                  )

                }
                self.backToOrderForm();
              }else{
                self.bypassConfirmation = false;
              }
            },
            addAssetToProgram:function(flag){
                var self = this;

                var data = this.$refs['listVehicleTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleTable'].selectedRows[i].id)
                }

                var program = self.$route.query.pr;
                var fields = [];
                self.start_point_date_error_msg = '';
                if (flag != 'skip'){
                    if (self.start_point_date == '' || self.start_point_date == null || self.start_point_date == undefined){
                        self.start_point_date_error_msg = 'Date Required';
                        return;
                    }
                }

                fields.push({name:'vehicles',value:JSON.stringify(use)});
                fields.push({name:'program_id',value:program});
                fields.push({name:'start_point_date',value:self.start_point_date});
                fields.push({name:'flag',value:flag});

                if (confirm('Are you sure that you want to add these Asset to Program? ')) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/program-asset/add",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            $("#programModal").modal('hide');
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);

                            if (data.code == '200') {
                                // self.$swal('','Asset Added Successfully','success');
                                $("#recallModal").modal('hide');
                                self.loadList();
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                                // var url = '&program='+program+'&recallText='+self.recalls.text;
                                                self.$router.push({ name: 'ProgramAssetMapperList', params: { id : program }});

                                        } else if (result.dismiss) {
                                            return;
                                        }
                                });

                            }
                        },
                        error: function (jqXHR, exception) {
                            $("#programModal").modal('hide');
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

            },

            openModal: function(){
                let self = this;
                self.importedCount = 0;
                self.selectedFile = "";
                $("#vehicleUploadFile").val('');
                self.import_error = '';
                $('#vehicle-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            generateExcelSample() {
                let self = this;
                self.loading = true;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/vehicle-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.file = data.content.web;

                        let docPath = self.file;
                        let save = document.createElement('a');
                        save.href = docPath;
                        save.download = docPath;
                        save.target = '_blank';
                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'vehicle-upload-generate')

                    }
                });
            },
            importVehicles() {
                let self = this;
                self.import_error = "";

                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                let fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                let formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/vehicle-excel/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {
                            if ( Object.keys(data.duplicate).length > 0){
                                self.importedCount = data.content;
                            }else{
                                if(data.content){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#vehicle-upload-modal').modal('hide');
                                self.loadList();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'vehicle-upload-import-error')
                    }
                });
            },

            openUpdateAssetModal: function() {

                let self = this;
                self.selectedAssetFile = "";
                self.unitnotfound = [];
                self.wrongdate = [];

                $("#assetFile").val('');
                self.import_update_asset_error = '';

                // ajax call for download sample excel file
                $.ajax({
                    url: process.env.ROOT_API + "/updateasset-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileUpdateAssetName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-import')

                    }
                });
                $('#asset-modal').modal('show');
            },
            onFileChangedUpdateAsset(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedAssetFile = file;
                self.import_update_asset_error = '';
            },
            downloadUpdateAssetSample(){
                let self = this;
                let docPath = self.file;
                let save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importUpdateAssetAsset() {
                let self = this;
                self.import_update_asset_error = "";
                if(self.selectedAssetFile == "" || self.selectedAssetFile == null){
                    self.import_update_asset_error = "Please Select Excel File.";
                    return;
                }
                let formData = new FormData();
                formData.append('myFile', self.selectedAssetFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/asset/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_update_asset_error = '';

                        if (data.code == 201) {
                            self.import_update_asset_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.unitnotfound).length > 0) {
                                self.unitnotfound = data.unitnotfound;
                            }
                            if(Object.keys(data.wrongdate).length > 0) {
                                self.wrongdate = data.wrongdate;
                            }
                            if ( data.content != false) {
                                self.$swal(''," Records imported",'success');
                            }
                            if ( Object.keys(data.unitnotfound).length == 0 && Object.keys(data.wrongdate).length == 0 ) {
                                $('#asset-modal').modal('hide');
                            }
                            self.import_update_asset_error = "";
                                // $('#asset-modal').modal('hide');
                            // self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'asset-import-error')
                    }
                });
            },
            createPO(){
              var self = this;
              var selectedData = this.$refs['listVehicleTable'].selectedRows;
              var userObj = JSON.parse(localStorage.getItem("user_obj"));
              var isNotCustomer = true;
              for (var i = 0; i < userObj.roles.length; i++) {
                // if (userObj.roles[i].name == "customer"){
                var roleName = userObj.roles[i].name;
                if (roleName.toLowerCase().includes("dealer")) {
                  isNotCustomer = false // false means user is customer
                }
              }
              if (isNotCustomer){
                // the validations here, when the logged in user is not a customer
                var validateSelectedData =  self.validateSelectedAssets(selectedData); // function checks if the all the assets have same or null customerid
                // if validateSelectedData is false, then the user is prompted accordingly
                if (!validateSelectedData){
                  self.$swal({
                    title: "",
                    text: "The selected assets have different customers, so the purchase order cannot be created!",
                    type: "error",
                    confirmButtonText: "Ok",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                  }).then(result => {
                      self.recalls = '';
                      return;
                  });
                }else{
                  self.createPoSwal(selectedData,isNotCustomer);
                }
              }else{
                self.createPoSwal(selectedData,isNotCustomer);
              }
            },

            PlaceOrder(){
              var self = this;
              var selectedData = this.$refs['listVehicleTable'].selectedRows;
              if (selectedData.length > 1){

                  self.$swal({
                    title: "",
                    text: "Order Cannot be placed for multiple vehicles at the same time!",
                    type: "error",
                    confirmButtonText: "Ok",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                  }).then(result => {
                      self.recalls = '';
                      return;
                  });
              }else if(selectedData[0].is_ordered == 1){
                self.$swal({
                    title: "",
                    text: "Order has already been placed for this vehicle.",
                    type: "error",
                    confirmButtonText: "Ok",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                  }).then(result => {
                      self.recalls = '';
                      return;
                  });
              }else{
                self.placeOrderSwal(selectedData[0].unit_no);
              }
            },

            validateSelectedAssets(array){
              var self = this;
              let firstNonNullCustomer = null;

              for (const item of array) {
                  const customer = item.customer_id;

                  if (customer !== null && customer !== "") {
                    // Set the first non-null customer if not already set
                    if (firstNonNullCustomer === null) {
                      firstNonNullCustomer = customer;
                      self.selectedCustomerFromAsset = firstNonNullCustomer // getting the customer id from the unit
                    } else if (customer !== firstNonNullCustomer) {
                      self.selectedCustomerFromAsset = null;
                      // If the current customer is not null and different from the first non-null customer, validation fails
                      return false;
                    }
                  }
                }

                // If the loop finishes without returning false, the validation passes
                return true;
            },

            createPoSwal: function(selectedData,isNotCustomer){
              var self = this;
              self.$swal({
                title: "",
                text: "Are you sure you want to create the customer PO?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                showCloseButton: true,
                showLoaderOnConfirm: true
              }).then(result => {
                if (result.value) {
                  var customerFromAsset = self.selectedCustomerFromAsset;
                  self.$router.push({ name: 'CustomerPurchaseOrderCreate', params:{selectedData,isNotCustomer,customerFromAsset}});
                } else if (result.dismiss) {
                  self.recalls = '';
                  return;
                }
              });
            },

            placeOrderSwal: function(unitNo){
              var self = this;
              self.$swal({
                title: "",
                text: "Are you sure you want to Place the order?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                showCloseButton: true,
                showLoaderOnConfirm: true
              }).then(result => {
                if (result.value) {
                  self.$router.push({ name: 'CustomerOrderForm', params:{unitNo}});
                } else if (result.dismiss) {
                  self.recalls = '';
                  return;
                }
              });
            },

            getActiveAssetList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getActiveAssetList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                localStorage.setItem('asset_list_prev_tab', 'active');
                self.activeSelected = 'active';
                self.inGarageSelected = '';
                self.soldSelected = '';
                self.voidSelected = '';
                self.allSelected = '';
                self.flag = 'active';
                self.loadList();
            },
            getAllAssetList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getAllAssetList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                localStorage.setItem('asset_list_prev_tab', 'all');
                self.activeSelected = '';
                self.inGarageSelected = '';
                self.soldSelected = '';
                self.voidSelected = '';
                self.allSelected = 'active';
                self.flag = 'all';
                self.loadList();
            },
            getInGarageAssetList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getInGarageAssetList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                localStorage.setItem('asset_list_prev_tab', 'ingarage');
                self.activeSelected = '';
                self.inGarageSelected = 'active';
                self.soldSelected = '';
                self.voidSelected = '';
                self.allSelected = '';
                self.flag = 'in garage';
                self.loadList();
            },
            getSoldAssetList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getSoldAssetList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                localStorage.setItem('asset_list_prev_tab', 'sold');
                self.activeSelected = '';
                self.inGarageSelected = '';
                self.soldSelected = 'active';
                self.voidSelected = '';
                self.allSelected = '';
                self.flag = 'sold';
                self.loadList();
            },
            getVoidAssetList: function(){
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getVoidAssetList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                localStorage.setItem('asset_list_prev_tab', 'void');
                self.activeSelected = '';
                self.inGarageSelected = '';
                self.soldSelected = '';
                self.voidSelected = 'active';
                self.allSelected = '';
                self.flag = 'void';
                self.loadList();
            },
            configureColumns(){
              let columnsToHide = [];
              let columnsToShow = [];
              var page = this.$route.path.split('/');
              if(page[1] == "all-vehicles" || page[1] == "available-vehicles-for-order"){
                columnsToHide.push('Dealer Code');
                columnsToHide.push('Dealer Name');
                columnsToHide.push('Purchase Date');
              }
              if(!this.viewOwnerShipFields){
                columnsToHide.push("Ownership");
                columnsToHide.push("Customer");
                columnsToHide.push("#Customer Unit");
              }
              if(this.viewDaysInStock){
                this.columns.push(
                  {
                    label: 'Days In Stock',
                    field: 'days_in_stock',
                    filterable: true,
                    fpFieldType: "integer",
                    hidden: false,
                    filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "Days in Stock", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                    }
                  }
                );
                // columnsToShow.push("days_in_stock");
              }
              for (let i = this.columns.length - 1; i >= 0; i--) {
                const column = this.columns[i];
                if (columnsToHide.includes(column.label)) {
                  this.columns.splice(i, 1);
                }
                if (columnsToShow.includes(column.field)) {
                  this.columns[i].hidden = false;
                }

              }
            },
            sortColumns(){
              let columnsToSort = [
                'Actions',
                'Dealer Code',
                'Dealer Name',
                'Vin',
                'Unit Number',
                'Year',
                'Model #',
                'Wheelbase',
                'Option Code',
                'Color',
                'Status',
                'Port Location',
                'Ownership',
                '#Customer Unit',
                'Customer'
              ];

              this.columns.sort((a,b) => {
                const indexA = columnsToSort.indexOf(a.label);
                const indexB = columnsToSort.indexOf(b.label);

                // If both labels are in the sorting array, sort based on their order
                if (indexA !== -1 && indexB !== -1) {
                  return indexA - indexB;
                }

                // If only one label is in the sorting array, prioritize it
                if (indexA !== -1) {
                  return -1;
                }

                if (indexB !== -1) {
                  return 1;
                }

                // If neither label is in the sorting array, maintain their original order
                return 0;
              });
            },
          sellVehicle() {
            if (confirm('Are you sure that you want to sell this vehicle? ')) {
              var self = this;
              var selectedData = this.$refs['listVehicleTable'].selectedRows;
              var fields = {
                vehicle_id: selectedData[0].id
              }
              self.loading = true;
              $.ajax({
                url: process.env.ROOT_API + "/vehicle-to-sold",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  self.loading = false;
                  setTimeout(function () {
                    $(".alert-success").removeClass("show");
                    $(".alert-success").addClass("hide");
                  }, 10000);
                  alert(data.message);
                  if (data.code == '200') {
                    self.loadList();
                  }
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  alert(data.message);
                  if (jqXHR.status == 0) {
                    self.error = "Remote server cannot be reached";
                  } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                      //clear previous data
                      localStorage.removeItem('user_obj');
                      localStorage.removeItem('tkn');

                      self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                  }
                }
              });
            }
          },
          goToGetLogInfo(logId) {
            var self = this;
            var logFlag = 'VEHICLES_AUDIT';
            self.getLogInfo(logId, logFlag);
          },
          saveVehicleSpecificationFilters() {
            var self = this;
            self.loading = true;
            const fieldToSpecMapping = {
              model_code: () => `${this.vehicleSpecification.select_class}${this.vehicleSpecification.batterySize}`,
              wheelbase: () => this.vehicleSpecification.wheelbase.substring(1),
              color: () => this.vehicleSpecification.vehicle_color,
              option_code: () => this.vehicleSpecification.vehicle_option.code,
              // Add more mappings as needed mapping should be same as the column field name
            };
            const columnFilterArr = this.columns
              .filter(column => column.filterable && fieldToSpecMapping[column.field])
              .map(column => {
                  let filtValue;
                  let filtOptionValue;
                  let filtType;
                  let filtTypeArr;
                  if (column.fpFieldType == 'option') {
                    filtValue = "";
                    filtOptionValue = fieldToSpecMapping[column.field]();
                    filtType = {
                      value: '=',
                      text: 'is',
                    };
                    filtTypeArr = [
                      {value: '=', text: 'is'},
                      {value: '!=', text: 'is not'},
                    ];
                  } else {
                    filtValue = fieldToSpecMapping[column.field]();
                    filtOptionValue = "";
                    filtType = {
                      value: 'like',
                      text: 'contains',
                    };
                    filtTypeArr = [
                      {value: 'like', text: 'contains'},
                      {value: 'not like', text: 'does not contain'},
                    ];
                  }
                  return {
                    columnId: {
                      label: column.label,
                      field: column.field,
                      filterable: column.filterable,
                      fpFieldType: column.fpFieldType,
                      hidden: column.hidden || false,
                      filterOptions: {
                        enabled: (column.filterOptions && column.filterOptions.enabled) || false,
                        placeholder: (column.filterOptions && column.filterOptions.placeholder) || column.label,
                        filterValue: (column.filterOptions && column.filterOptions.filterValue) || '',
                        trigger: (column.filterOptions && column.filterOptions.trigger) || 'enter',
                      },
                      typeDef: column.typeDef || {},
                    },
                    isColumnDisable: false,
                    filterValue: filtValue,
                    filterDateValue: null,
                    filterDateRangeValue: null,
                    filterOptionValue: filtOptionValue,
                    filterType: filtType,
                    filterTypeArr: filtTypeArr,
                  }
                }
              );
            $.ajax({
              url: process.env.ROOT_API + "/store-filters",
              type: "POST",
              headers: this.ajxHeaders,
              data: {
                search: 'Temp filter',
                filters: JSON.stringify(columnFilterArr),
                list_name: self.listName,
                privacy: 'temp',
                columns: JSON.stringify(self.columns),
                sort: JSON.stringify(self.serverParams.sort),
                filterId: self.tempFilterId
              },
              dataType: "json",
              success: function (data) {
                self.loading = false;
                $("#storeFilter").prop('disabled', false);
                //self.loading = false;
                if (data.code == 201) {
                  self.$swal('', data.message, 'info');
                }
                if (data.code == 200) {

                  //add filter in filter option if not added before
                  self.tempFilterId = data.content.id;
                }
              },
              error: function (jqXHR, exception) {
                self.loading = false;
                //self.loading = false;
                $("#storeFilter").prop('disabled', false);
                if (jqXHR.status == 0) {
                  self.errorMsg = "Remote server cannot be reached";
                } else {
                  //redirect to login page if user not authenticated
                  if (jqXHR.status == 401) {
                    //clear previous data
                    localStorage.removeItem("user_obj");
                    localStorage.removeItem("tkn");
                    //EventBus.$emit("logged-in", true, "", "");
                    self.$router.push("/");
                  }
                  self.error = jqXHR.responseJSON.message;
                }
              }
            });
          },
          backToOrderPopUp(){
            this.$swal({
              title: "Go back to the order form?",
              text: "Selected vehicles won't be assigned..",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
            }).then(result => {
              if (result.value) {
                this.backToOrderForm()
              }
            });
          },
          backToOrderForm(){
            this.bypassConfirmation = true;
            this.$router.push(
              {
                name: 'CustomerOrderFormEdit',
                params: {id: this.$route.query.order},
                query: {
                  from: "available_vehicles_list",
                },
              }
            ).then(() => {
              window.history.replaceState({}, '', this.$route.path);
            });
          },
          beforeWindowUnload(event) {
            if (!this.bypassConfirmation) {
                event.preventDefault();
                event.returnValue = '';
            }
          },
          redirectToVehicleOrderTracking(){
            this.$swal('', `Redirected to the vehicle order tracking page.`, 'info');
            this.loading = true;
            this.$router.push({
              name: 'CustomerOrderList'
            });
          }
        }
    };
</script>
<style scoped>
label.d-block {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetList.vue